<template>

    <header class="bg-blue-nutri flex items-center justify-between flex-wrap">
          <div class="md:w-auto w-2/4 relative py-5 px-6">
            <img class="logo" :src="$page.props.asset_url + '/vendor/nutristudents/image/logo.png'" alt="Menu Freedom Logo">
          </div>

            <div class="relative flex ml-auto">
            </div>
    </header>
</template>

<script>



export default {

  data: function () {
    return {
    }
  },

  methods: {

  },


}

</script>

<style>
.bg-blue-nutri {
  background-color: #365491;
}
.bg-blue-second{
    background-color: #29447e;
}
.bg-icon{
     background-color: #ffc919;
}

.help_info {
    top: 96px;
    right: 0;
    z-index: 99;
    color: #fff;
    width: 290px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.35s;
}
.help_box:hover .help_info,.help_box:focus .help_info{
  opacity: 1;
    visibility: visible;
}
.sub-menu{
  opacity: 0;
  visibility: hidden;
  transition: all 0.35s;
  border-top: 1px solid #365491;
}
.user-menu:hover .sub-menu{
  opacity: 1;
  visibility: visible;
}


.id-color,.cart-color,.id-color-menu-edit,.menu1-text-color,.text-color-first-li {
    color: #0092d0 !important;
}

.button-color,.menu1-background-color {
    background-color: #39b54a !important;
}
.active::before,.products-edit-minus-color{
  color: #39b54a !important;
}
.arrow-color {
    color: #0092d0 !important;
}
.title_color {
    color: #0092d0 !important;
}
.bg-white.popup-shadow {
    top: 10px;
    right: 24px;
    padding: 6px 0;
    font-size: 14px;
    width: 170px;
}
.bg-white.popup-shadow li.text-black {
    line-height: normal;
    margin-bottom: 4px;
}
button.menu1-background-color.rounded-full {
    background: #ffc919;
}
button.lg\:w-1\/5.w-16.xl\:inline-flex.justify-center.rounded-md.font-bold.px-4.py-2.uppercase.menu1-background-color.text-white.focus\:outline-none.mr-3.sm\:mt-0.mt-2 {
    background-color: #39b54a !important;
}
div.select-menu-height,div.select-menu-height-edit2 {
    background-color: #39b54a !important;
}
.cancel-background-color {
    background-color: #6b7280 !important;
}
</style>
